import {Service} from 'vue-di-container';


export interface StateMessage {
  type: 'warning' | 'success';
  title: string;
  body: string;
}

@Service()
export default class MemoryService {

  public id: number = -1;
  private homeMessage1: StateMessage | null = null;

  public get homeMessage() {
    if (this.homeMessage1) {
      const m: StateMessage = {
        title: this.homeMessage1.title,
        type: this.homeMessage1.type,
        body: this.homeMessage1.body,
      };
      this.homeMessage1 = null;
      return m;
    } else {
      return null;
    }
  }

  public set homeMessage(message) {
    this.homeMessage1 = message;
  }

  constructor() {

    this.id = Math.floor(Math.random() * 1000);
  }

}
